import { localStorageInstance } from '@gem/modules/storage';

import { EmojiCategoryName } from 'APP/constants/emojis';

const KEY_NAME = 'selected-emoji-category';

export const set = (selectedCategory: EmojiCategoryName): void =>
  localStorageInstance.setItem(KEY_NAME, selectedCategory);

export const get = (): EmojiCategoryName | null => localStorageInstance.getItem(KEY_NAME);

export const remove = (): void => localStorageInstance.removeItem(KEY_NAME);
